import { render, staticRenderFns } from "./DxClients.vue?vue&type=template&id=63c0515d&"
import script from "./DxClients.vue?vue&type=script&lang=js&"
export * from "./DxClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports